export default {
  hoverColour: 'brandOne100',
  backgroundColor: 'utilityWhite',
};
